import React from "react";
import { Col, Form, Select } from "antd";
import { Rule } from "antd/es/form";
import { SelectProps } from "antd/es/select";
import { ColProps } from "antd/es/col";
import map from "lodash/map";

const { Option } = Select;

// Reuse the FormItemProps from the previous example
import { FormItemProps } from './ScaleFormItem';

interface SelectOption {
  value: string | number;
  text: React.ReactNode;
}

interface ScaleSelectProps extends Omit<SelectProps<any>, 'options'>, FormItemProps {
  data: SelectOption[];
  span?: number;
  colProps?: ColProps;
}

const ScaleSelect: React.FC<ScaleSelectProps> = ({
                                                   data,
                                                   name,
                                                   label,
                                                   span = 24,
                                                   rules,
                                                   size = "large",
                                                   colProps,
                                                   ...rest
                                                 }) => {
  return (
      <Col span={span} {...colProps}>
        <Form.Item name={name} label={label} rules={rules}>
          <Select size={size} {...rest}>
            {map(data, ({ value, text }) => (
                <Option value={value} key={value}>
                  {text}
                </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
  );
};

export default ScaleSelect;